// src/components/FullWidthContainer.js

import React from 'react';
import { Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// const FullWidthContainer = ({ children, sx = {}, ...props }) => {
//     const theme = useTheme();

//     return (
//         <Container
//             maxWidth={false}
//             sx={{
//                 backgroundColor: `${theme.palette.common.mainBody}`,
//                 minHeight: '100vh',
//                 width: '100%',
//                 paddingLeft: 0,
//                 paddingTop: 0,
//                 paddingRight: 0,
//                 marginLeft: 0,
//                 marginRight: 0,
//                 ...sx,
//             }}
//             {...props}
//         >
//             {children}
//         </Container>
//     );
// };

// export default FullWidthContainer;


export const FullWidthContainer = ({ children }) => {
    const theme = useTheme();
    return (
        <Container 
            maxWidth={false} 
            sx={{
                backgroundColor: `${theme.palette.common.mainBody}`,
                minHeight: '100vh',
                width: '100%',
                paddingLeft: 0,
                paddingTop: 0,
                paddingRight: 0,
                marginLeft: 0,
                marginRight: 0,
            }}
        >
            {children}
        </Container>
    );
};
